
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/code-of-conduct",
      function () {
        return require("private-next-pages/code-of-conduct.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/code-of-conduct"])
      });
    }
  